export const CULTURAL_GALLERY=[
  {
    "displayText": "22",
    "filename": "./assets/img/gallery/cultural/22.JPG",
    "link": ""
  },
  {
    "displayText": "23",
    "filename": "./assets/img/gallery/cultural/23.JPG",
    "link": ""
  },
  {
    "displayText": "24",
    "filename": "./assets/img/gallery/cultural/24.JPG",
    "link": ""
  },
  {
    "displayText": "25",
    "filename": "./assets/img/gallery/cultural/25.JPG",
    "link": ""
  },
  {
    "displayText": "DANCE",
    "filename": "./assets/img/gallery/cultural/DANCE.jpeg",
    "link": ""
  },
  {
    "displayText": "FOOD FESTIVAL",
    "filename": "./assets/img/gallery/cultural/FOOD FESTIVAL.jpeg",
    "link": ""
  },
  {
    "displayText": "GANPATI FESTIVAL",
    "filename": "./assets/img/gallery/cultural/GANPATI FESTIVAL.jpg",
    "link": ""
  },
  {
    "displayText": "SHRAVANI SOHALA (1)",
    "filename": "./assets/img/gallery/cultural/SHRAVANI SOHALA (1).jpeg",
    "link": ""
  },
  {
    "displayText": "TRADITIONAL DAY 2",
    "filename": "./assets/img/gallery/cultural/TRADITIONAL DAY 2.jpeg",
    "link": ""
  },
  {
    "displayText": "TRADITIONAL DAY",
    "filename": "./assets/img/gallery/cultural/TRADITIONAL DAY.jpeg",
    "link": ""
  }
]